import { render, staticRenderFns } from "./UserVaultBalance.vue?vue&type=template&id=6d43ff6c&"
import script from "./UserVaultBalance.vue?vue&type=script&lang=js&"
export * from "./UserVaultBalance.vue?vue&type=script&lang=js&"
import style0 from "./UserVaultBalance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports